export enum TrainingsPermissions {
  RioConnections = 'rio-connections',
  Training = 'training',
  Sector = 'sector',
  CreboFile = 'crebo-file',
  Crebo = 'crebo',
  StudentFetchService = 'student-fetch-service',
}
